import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../service/report.service';
import { NotifierService } from 'angular-notifier';
// import { file } from 'jszip';

@Component({
  selector: 'app-download-all-files',
  templateUrl: './download-all-files.component.html',
  styleUrls: ['./download-all-files.component.scss']
})
export class DownloadAllFilesComponent implements OnInit {
  public ahref:HTMLElement;
  public selectedTab:string;
  public selectedFiles:string[]=[];
  public searchText:string = "";
  public isCheckedSelectAll:boolean=false

  constructor(public reportService: ReportService,
    public notifier: NotifierService) { 
  }

  ngOnInit(): void {
    this.selectedTab = this.reportService.isHideFileListForSpecificStudies ? 'download_files' : 'files';
  }
  

  downloadFile(file){
    this.ahref = document.getElementById("downloadFIleURL");
    // let filename = file.filename.replace(/\s/g, '');
    // filename = filename + ".zip"
    this.ahref.setAttribute("href", file.url);
    this.ahref.setAttribute("target", "_blank");
    this.ahref.setAttribute(
      "download",
      file.filename
    );
    this.ahref.click()
  }

  switchTab(tab){
    // this.searchText = '';
    // this.selectedFiles = [];
    this.selectedTab = tab;
    if (tab === 'download_files' && !this.reportService.isHideFileListForSpecificStudies) {
      this.reportService.getAllDownloadableZipFiles(this.reportService.detailsUUID)
    }else{
      this.reportService.isDownloadableFileProcessing = false;
    }
  }

  onCheckChanged(fileUUID){
    if (this.checkFileSelected(fileUUID)) {
      const index = this.selectedFiles.indexOf(fileUUID);
      if (index > -1) {
        this.selectedFiles.splice(index, 1); 
        this.isCheckedSelectAll = false;
      }
    }else{
      this.selectedFiles.push(fileUUID)
    }
  }

  checkFileSelected(fileUUID){
    return this.selectedFiles.includes(fileUUID) ? true :false
  }

  selectAllFiles(isChecked){
    this.isCheckedSelectAll = isChecked
    if (this.isCheckedSelectAll) {
      this.selectedFiles = this.reportService.allFileListOfRepo.map( file => file.file_uuid);
    }else{
      this.selectedFiles = []
    }
    // console.log("selected files",this.selectedFiles.length); 
  }


  onSearchChange(value){
    this.searchText = value;
    this.reportService.allFileListOfRepo = this.reportService['allFileListOfRepoBackup'].filter((item) =>{return (item.name && item.name.toLowerCase().includes(this.searchText.toLowerCase())) || (item.file_type && item.file_type.toLowerCase().includes(this.searchText.toLowerCase()))});
  }

  onSubmitQueue(){
    let body = {
      "study_id": this.reportService.detailsUUID,
      "type": "files",
      "file_uuids": this.selectedFiles
    }
    if (this.isCheckedSelectAll) {
      if(this.searchText == ''){
        body['type'] = "select_all";
        body['file_uuids'] = [];
      }
    }
    // console.log("body",JSON.stringify(body));
    if (this.selectedFiles && this.selectedFiles.length) {
      this.reportService.setQueueForDownloadAll(body).subscribe(result=>{
        if (result['status'] == 1) {
          this.notifier.notify('success','Files are added to the queue');
          this.selectedFiles = [];
          this.isCheckedSelectAll = false;
          this.switchTab('download_files')
        }else{
          this.notifier.notify("error",result['message'])
        }
      },error =>{
        this.notifier.notify("error","Something went wrong!")
      })
    }else{
      this.notifier.notify("error","Please select some files")
    }
  }

}
